/* eslint-disable camelcase */
import { d3, gettext } from "../adapter";

var months = [
  null,
  gettext("January"),
  gettext("February"),
  gettext("March"),
  gettext("April"),
  gettext("May"),
  gettext("June"),
  gettext("July"),
  gettext("August"),
  gettext("September"),
  gettext("October"),
  gettext("November"),
  gettext("December"),
].slice(0);
var shortMonths = [
  null,
  gettext("Jan"),
  gettext("Feb"),
  gettext("Mar"),
  gettext("Apr"),
  gettext("May"),
  gettext("Jun"),
  gettext("Jul"),
  gettext("Aug"),
  gettext("Sept"),
  gettext("Oct"),
  gettext("Nov"),
  gettext("dec"),
].slice(0);

months.shift();
shortMonths.shift();

var locale = {
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  dateTime: "%a %b %e %X %Y",
  date: "%d/%m/%Y",
  time: "%H:%M:%S",
  periods: ["", ""],
  days: [
    gettext("Sunday"),
    gettext("Monday"),
    gettext("Tuesday"),
    gettext("Wednesday"),
    gettext("Thursday"),
    gettext("Friday"),
    gettext("Saturday"),
  ],
  shortDays: [
    gettext("Su"),
    gettext("Mo"),
    gettext("Tu"),
    gettext("We"),
    gettext("Th"),
    gettext("Fr"),
    gettext("Sa"),
  ],
  months: months,
  shortMonths: shortMonths,
};

d3.time.format = d3.locale(locale).timeFormat;
var graph_locale = d3.time.format.multi([
  [
    ".%L",
    function (d) {
      return d.getMilliseconds();
    },
  ],

  [
    ":%S",
    function (d) {
      return d.getSeconds();
    },
  ],

  [
    "%H:%M",
    function (d) {
      return d.getMinutes();
    },
  ], // 16:00

  [
    "%H:%M",
    function (d) {
      return d.getHours();
    },
  ], // 16:00

  [
    gettext("%a %e"),
    function (d) {
      return d.getDay() && d.getDate() !== 1;
    },
  ], // di 5

  [
    gettext("%e %b"),
    function (d) {
      return d.getDate() !== 1;
    },
  ], // 3 mei

  [
    "%b",
    function (d) {
      return d.getMonth();
    },
  ], // april

  [
    "%Y",
    function () {
      return true;
    },
  ], // 2015
]);

const chartTimeFormat = { chart: graph_locale, brush: graph_locale };

export default chartTimeFormat;
